var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 14.118,
    viewBox: "0 0 25 14.118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 25,
    height: 14.118,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAOCAYAAAA45qw5AAACOUlEQVQ4jY2V32vPYRTHX/uymW02K7WN4QY3VpQfW0qTIonUUjL+AylTW32ba278KHInRPlx5cfVuOPGpYQY5VcuhguzyBjeOvX+1NOnz/bZu07f55znPN/znPc5z/nUSKIEl4BXwGWgF5gHNPn3HzBpvQGoAeYA9d7/bvtzYCewCVgG/J5bErQN6ADW+PCNsltOg1VAH3ARaAU+ERnPIOskDUlaKOmppMES/yLplvRW0npJKyRtDp/IuBNYbHqC979BBfAY+AUsBcaBHuCWfQdmmelBoArsBp4Bu4A/sRGBVwNbgBY7R7BvwBfXcML2H8B24DpwE9hXEnQQOODavrctemEqC3zPUoS12Q0T7AdOAA+BPcDXgnMn3Rc9br4MlWyRNlcXsBeo862uAWPuzDyqpvuq6RxP9k8D7cC2gnNTKdUZwvDZ9EaNf+aozuMM0O2Mow8+ui8WWS9Cc8ZAGvilJcVKYH7BH9T5aXzw2z7vpjvnvbvA4aS2KdUN+cCBjcBROwRlo262FJHlWeAOcNz2YGcJcNv6hIOfAq4kZ2s9WMi/u3pJ7ZbQOyX1J/vDkp5I6p3F+10uaUTSBUnNtlUlHYl1JZfNpBtqzHrU+A2wwM3W5owfTFPDFEHzDuCF/ePs6+w5zXTjiuWQpFFJx2yP+R6TrFVSk6RGS4v1yC4k9Fqf2SrpkaR3kvqyyVWEGPYbfMt+16XRkysQH4KwBUPhG9Mu2At7TL+oeexHdrEeAe776XUAXf8B2ZGAmhjaTScAAAAASUVORK5CYII="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.b7587c00a4a4757b148b9db9c7dc4522.svg";
export { ForwardRef as ReactComponent };